// Global constant storage reactId history
class Bus {
    globalReactId = null
    globalHistory = null
    globalProps = null
    setReactId = (reactId) => {
        if (!this.globalReactId) {
            this.globalReactId = reactId
        }
    }
    setHistory = (history) => {
        if (!this.globalHistory) {
            this.globalHistory = history
        }
    }
    setProps = (globalProps) => (this.globalProps = globalProps)
    // Store some global variables
    setDangerousVar = (key, value) => {
        this[key] = value
    }
    getDangerousVar = (key) => this[key]
    get reactId() {
        return this.globalReactId
    }
    get history() {
        return this.globalHistory
    }
}

export default new Bus()
